import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomHeaderUtil } from '@b3networks/shared/common';
import { HashMap } from '@datorama/akita';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { GetSubscribedProductReq, PurchaseSubscriptionRequest, SubscribedProduct } from './subscribed-product.model';

@Injectable({
  providedIn: 'root'
})
export class SubscribedProductService {
  trialHash: HashMap<boolean> = {};

  constructor(private http: HttpClient) {}

  getSubscribedProducts(subscribedProductReq: GetSubscribedProductReq): Observable<SubscribedProduct> {
    const query = new HttpParams()
      .set('includeAll', String(subscribedProductReq.includeAll))
      .set('assigneed', subscribedProductReq.assigneed)
      .set('subscriptionStatus', subscribedProductReq.subscriptionStatus);
    return this.http
      .get<SubscribedProduct>(`/subscription/private/v3/subscribedproducts`, {
        headers: CustomHeaderUtil.onBelfOfCustomerHeader,
        params: query
      })
      .pipe(map(res => new SubscribedProduct(res)));
  }

  getSubscribedProductsV4(orgUuid: string, subscriptionStatus: string): Observable<[{ id: string; name: string }]> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    let params = new HttpParams();

    if (orgUuid) {
      headers = headers.set('x-user-org-uuid', orgUuid);
    }
    if (subscriptionStatus) {
      params = new HttpParams().set('subscriptionStatus', subscriptionStatus);
    }

    return this.http.get<[{ id: string; name: string }]>(`/subscription/private/v4/subscribedproducts`, {
      headers: headers,
      params: params
    });
  }

  buySubscribe(body: PurchaseSubscriptionRequest, headers?: HttpHeaders): Observable<SubscribedProduct> {
    return this.http.post<SubscribedProduct>(`/subscription/private/v3/subscribe`, body, {
      headers: headers
    });
  }

  canSubscribeTrial(productId: string, skuCode: string): Observable<any> {
    const params = new HttpParams().set('productId', productId).set('sku', skuCode);

    return this.http.get(`/subscription/private/v3/subscribe/trial`, { params }).pipe(
      tap((res: any) => {
        this.trialHash[productId] = res.trial;
      })
    );
  }
}
